import { render } from "./RotatingObjectComponent.vue?vue&type=template&id=445debd8&scoped=true"
import script from "./RotatingObjectComponent.vue?vue&type=script&lang=js"
export * from "./RotatingObjectComponent.vue?vue&type=script&lang=js"

import "./RotatingObjectComponent.vue?vue&type=style&index=0&id=445debd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445debd8"]])

export default __exports__